import { dateLib } from "@/utils/date";

export const pageMonCompteToutesMesCommandesProps = () => ({
  commandes: {
    type: Array,
    required: false,
    default() {
      return [];
    }
  }
})

export const usePageMonCompteToutesMesCommandes = (props) => {

  const filterType = ref("fixed-all")
  const sortType = ref("date_desc")

  const allYears = computed(() => {
    return props.commandes.map((commande) => {
      return commande.attributes.date_commande.substring(0, 4);
    }).filter((year, index, arr) => {
      return arr.indexOf(year) === index;
    });
  })
  const isFixedFilter = computed(() => {
    return filterType.value.indexOf("fixed") === 0;
  })
  const filteredYears = computed(() => {
    let years = allYears.value;
    if (!isFixedFilter.value) {
      years = allYears.value.filter((year) => {
        return year === filterType.value;
      });
    }

    if (sortType.value === "date_asc") {
      return [...years].reverse();
    }

    return years;
  })
  const filteredCommandes = computed(() => {
    const commandes = filter(props.commandes, !isFixedFilter.value ? filterType.value : null);
    return sort(commandes);
  })
  const commandesByYear = computed(() => {
    return filteredYears.value.map((year) => {
      return {
        year,
        commandes: getCommandesByYear(year)
      }
    });
  })
  const noCommandesToDisplay = computed(() => {
    const nbByYear = commandesByYear.value.reduce((acc, val) => {
      return acc + val.commandes.length;
    }, 0);
    return filteredCommandes.value === 0 || nbByYear === 0;
  })

  const getCommandesByYear = (year) => {
    let commandes = props.commandes.filter((commande) => {
      return commande.attributes.date_commande.substring(0, 4) === year;
    });
    commandes = filter(commandes);
    return sort(commandes);
  }
  const filter = (commandes, year = null) => {
    return commandes.filter((commande) => {
      if (filterType.value === "fixed-month") {
        return dateLib().isSame(commande.attributes.date_commande, 'month');
      } else if (filterType.value === "fixed-3months") {
        const past = dateLib().subtract(3, 'month');
        const dateCommande = dateLib(commande.attributes.date_commande, "YYYY-MM-DD HH:mm:ss", 'fr')
        return dateCommande.isAfter(past);
      } else if (filterType.value === "fixed-6months") {
        const past = dateLib().subtract(6, 'month');
        const dateCommande = dateLib(commande.attributes.date_commande, "YYYY-MM-DD HH:mm:ss", 'fr')
        return dateCommande.isAfter(past);
      } else if (year) {
        return commande.attributes.date_commande.substring(0, 4) === year;
      } else {
        return true;
      }
    });
  }
  const sort = (commandes) => {
    if (sortType.value === "date_asc") {
      return commandes.sort((a, b) => {
        const dateA = dateLib(a.attributes.date_commande, "YYYY-MM-DD HH:mm:ss", 'fr');
        const dateB = dateLib(b.attributes.date_commande, "YYYY-MM-DD HH:mm:ss", 'fr');
        return dateA.isBefore(dateB) ? -1 : 1;
      })
    }
    if (sortType.value === "montant_desc") {
      return commandes.sort((a, b) => {
        const montantA = parseFloat(a.attributes.montant_total_ttc);
        const montantB = parseFloat(b.attributes.montant_total_ttc);
        return montantA > montantB ? -1 : 1;
      });
    }
    if (sortType.value === "montant_asc") {
      return commandes.sort((a, b) => {
        const montantA = parseFloat(a.attributes.montant_total_ttc);
        const montantB = parseFloat(b.attributes.montant_total_ttc);
        return montantA > montantB ? 1 : -1;
      });
    }

    return commandes;
  }

  return {
    filterType,
    sortType,
    allYears,
    isFixedFilter,
    filteredYears,
    filteredCommandes,
    commandesByYear,
    noCommandesToDisplay,
    getCommandesByYear,
    filter,
    sort
  }
}